"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function Button(props) {
  var classes = "inline-container ".concat(props.size, " ").concat(props.type);
  var disabled = props.disabled ? 'disabled' : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    disabled: disabled,
    style: props.disablePointerEvents ? {
      pointerEvents: 'none'
    } : {},
    className: classes,
    onClick: props.onClick,
    children: [props.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: props.icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: props.children
    }), props.loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: "loader"
    })]
  });
}

Button.propTypes = {
  children: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  icon: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'large']),
  type: _propTypes.default.oneOf(['primary', 'secondary']),
  onClick: _propTypes.default.func.isRequired,
  disablePointerEvents: _propTypes.default.bool
};
Button.defaultProps = {
  disabled: false,
  disablePointerEvents: false,
  loading: false,
  size: 'small',
  type: 'secondary'
};
var _default = Button;
exports.default = _default;
//# sourceMappingURL=Button.js.map